export default function initialState() {
    return {
        branches: {
            __loading__: false,
            __error__: null
        }
    };
}
